// Shared theme + helpers for the Dr Raju Ayurvedic Wellness Centre app
// Earthy/green palette, distinct from the Medhasvi HealthAI brand.

export const WELLNESS_THEME = {
  primary: '#2f5d50',      // deep emerald
  primaryLight: '#5b8b7e',
  accent: '#c89b3c',       // warm gold
  accentLight: '#e8c373',
  bgCream: '#faf7ef',
  bgWarm: '#f3ece0',
  text: '#2a2620',
  muted: '#6b6358',
  border: '#e0d6c2',
};

export const ADMIN_TOKEN_KEY = 'wellness_admin_token';

// Resolve backend URL at runtime (avoids circular import from App.js).
// Mirrors the same logic used in App.js so wellness pages work on both
// preview (env-baked URL) and custom domains (same-origin).
const _resolveBackend = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isPreview = host.includes('preview.emergentagent.com');
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    if (!isPreview && !isLocal) return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL;
};

export const WELLNESS_API = `${_resolveBackend()}/api/wellness`;

export const fmtUSD = (n) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n || 0);

export const today = () => new Date().toISOString().slice(0, 10);
export const addDays = (iso, n) => {
  const d = new Date(iso);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
export const nightsBetween = (ci, co) =>
  Math.max(0, Math.round((new Date(co) - new Date(ci)) / (1000 * 60 * 60 * 24)));
